import React, { useState, useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { Button, Box, Typography } from '@mui/material';

const ImageUploadInput = ({onFileSelect, selectedImage}) => {
    const [image, setImage] = useState(null);

    // Create image url to display preview and send file data to parent component
    const onDrop = useCallback((acceptedFiles) => {
        const file = acceptedFiles[0];
        setImage(URL.createObjectURL(file));
        // Send file to parent component
        onFileSelect(file);
    }, []);
  
    // Library to handle drop interaction
    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: 'image/*',
        multiple: false,
    });
  
    const handleRemoveImage = () => {
        setImage(null);
        onFileSelect(null);
    };

    // useEffect to show the image when the edit modal is opened
    useEffect(() => {
        if(selectedImage) setImage(selectedImage)
    }, [selectedImage])
  
    return (
        <Box
            sx={{
                border: '2px dashed grey',
                borderRadius: '5px',
                padding: '20px',
                textAlign: 'center',
                cursor: 'pointer',
                position: 'relative',
                height: '345px',  // Fixed height for the drag-and-drop area
                width: '100%',   // Ensure the area does not shrink
                maxWidth: '600px', // Optional: Set a max width if you want to limit it
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <div {...getRootProps()} style={{ width: '100%', height: '100%' }}>
                <input {...getInputProps()} />
                
                {!image ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                            width: '100%',
                            flexDirection: 'column',
                        }}
                    >
                        <Typography variant="body1">
                            Haz clic o arrastra una imagen
                        </Typography>
                    </Box>
                ) : (
                    <Box
                        sx={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <img
                            src={image}
                            alt="Preview"
                            style={{
                                maxWidth: '100%',
                                maxHeight: '100%',
                                objectFit: 'contain',
                            }}
                        />
                        <button
                            onClick={handleRemoveImage}
                            className='save-modal-button'
                            style={{width: '130px', marginTop: '10px'}}
                        >
                            Quitar imagen
                        </button>
                    </Box>
                )}
            </div>
        </Box>
    );
};

export default ImageUploadInput;